var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 7.49984V4.99984M10.0013 18.3332C6.77964 18.3332 4.16797 15.7215 4.16797 12.4998V7.49984C4.16797 4.27818 6.77964 1.6665 10.0013 1.6665C13.223 1.6665 15.8346 4.27818 15.8346 7.49984V12.4998C15.8346 15.7215 13.223 18.3332 10.0013 18.3332Z",
    stroke: "#57AB69",
    strokeWidth: 0.854167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseIcon);
export default __webpack_public_path__ + "static/media/mouse_icon.f7f4395956d27d76fef32cf22f7eacbf.svg";
export { ForwardRef as ReactComponent };